export default "__VITE_ASSET__ej6qgEgV__"